import $ from 'jquery'
import { alert_error, post_json, get_json, eval_html_template,
         get_myinfo, has_user_loggedin } from '../common'

$(init)

async function init () {
  let $page = $('#pricing-page')
  if ($page.length == 0) {
    return
  }
  try {
    let plans = (await get_json('/premium/get-plans')).data
    $page.find('.loading-indicator').addClass('d-none')
    let $packages = $('#packages')
    $('#packages-wrp').removeClass('d-none')
    $packages.html('')
    for (let plan of plans) {
      if ((plan.price+'').endsWith('.00')) {
        plan.price = plan.price.substring(0, plan.price.length - 3)
      }
      $packages.append(eval_html_template('#package-template', plan))
    }
    $packages.on('click', '.buynow-btn', async ($evt) => {
      try {
        let plan_id = $($evt.target).data('plan-id')
        if (!plan_id) {
          console.error('data-plan-id is not defined!', $evt.target)
          return
        }
        let myinfo = await get_myinfo()
        let loggedin = has_user_loggedin(myinfo)
        if (!loggedin) {
          $(document).trigger('x-show-login-modal')
          return
        }
        let data = await post_json('/api/order/create', {
          payment_method: 'stripe',
          lines: [
            {
              item_type: 'package',
              quantity: 1,
              package_id: '__pp__' + plan_id,
            }
          ],
        })
        window.location = `/u/order/view/?id=${data.order_id}`
      } catch (err) {
        $page.find('.loading-indicator').addClass('d-none')
        alert_error(err)
      }
    })
  } catch (err) {
    $page.find('.loading-indicator').addClass('d-none')
    alert_error(err)
  }
}
